import React, {useEffect, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import "./Reward.scss";
import {Nav} from "../../Components";
import {ReportData} from "../Report/ReportServices";
import {
    ConvertToJalali,
    FactorData, MallCreditCard,
    MallRewardsData,
    MallRewardsDataPage,
    RewardsData, UserCouponData, UserCouponDataPage
} from "../StoreDetail/StoreDetailServices";
import Skeleton from "react-loading-skeleton";
import SimpleLineIcon from "react-simple-line-icons";
import Rodal from "rodal";
import QRCode from "react-qr-code";
import moment from "moment-jalaali";
import {getFestivalsStatus_api} from "../../Services/apis";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import {StoreOnlineCreateInvoice} from "../Payment/PaymentService";
import HomeResponsive from "../HomeResponsive/HomeResponsive";
import RewardResponsive from "../RewardResponsive/RewardResponsive";
import {useResp} from "../../hooks";
import {Modal} from "antd";
let globalActiveTab = "order"

let reward_next = ""
let reward_history_next = ""


const convertStatusCode = (code) =>{
    let result =""
    switch (code) {
        case 1:
            result  =  "اولیه"
            break;
        case 2:
            result  =  "آماده پرداخت"
            break;
        case 3:
            result  =  "نهایی شده توسط مشتری"
            break;
        case 5:
            result  =  "رد شده توسط صندوقدار"
            break;
        case 9:
            result  =  "شروع جمع آوری"
            break;
        case 10:
            result  =  "جمع آوری شده"
            break;
        case 13:
            result  =  "آماده ارسال"
            break;
        case 14:
            result  =  "در حال پیدا کردن پیک"
            break;
        case 15:
            result  =  "قبول شده توسط پیک"
            break;
        case 20:
            result  =  "در حال ارسال"
            break;
        case 25:
            result  =  "تحویل شده"
            break;
        case 30:
            result  =  "توسط مشتری کنسل شد"
            break;
        case 31:
            result  =  "توسط داروخانه کنسل شد"
            break;
        case 32:
            result  =  "توسط میاره کنسل شد"
            break;
    }

    return result;

}


const convertStatusStyle = (code) =>{
    let result =""
    switch (code) {
        case 1:
            result  = "#7d7d7d" // "اولیه"
            break;
        case 2:
            result  =  "#eaa55a" //"آماده پرداخت"
            break;
        case 3:
            result  = "#9cb823" // "نهایی شده توسط مشتری"
            break;
        case 5:
            result  =  "#c24d4d" // "رد شده توسط صندوقدار"
            break;
        case 9:
            result  =  "#f5c85c" // "شروع جمع آوری"
            break;
        case 10:
            result  =  "#82ad48" //"جمع آوری شده"
            break;
        case 13:
            result  =  "#64cace"  //"آماده ارسال"
            break;
        case 14:
            result  =  "#e5d24e" //"در حال پیدا کردن پیک"
            break;
        case 15:
            result  =  "#33af79"  //"قبول شده توسط پیک"
            break;
        case 20:
            result  =  "#4da8d9" //"در حال ارسال"
            break;
        case 25:
            result  = "#62db64" // "تحویل شده"
            break;
        case 30:
            result  =  "#d05a5a" //"توسط مشتری کنسل شد"
            break;
        case 31:
            result  =  "#d05a5a" //"توسط دیجیمال کنسل شد"
            break;
        case 32:
            result  =  "#d05a5a" //"توسط میاره کنسل شد"
            break;
    }

    return result;

}


function InvCard_skeleton({show}) {

    return (
        <>
            {show ? <div className="report-card">
                <div className="price">
                    <span><Skeleton width={50}/></span>
                </div>
                <div className="info">
                    <span><Skeleton width={100}/></span>
                    <Skeleton width={60} height={60} circle={true}/>
                </div>
            </div> : null}
        </>
    )
}

function numberWithCommas(x) {
    // convert To toman
    // x= (x/10).toFixed(0)
    //add commas
    if(x){
        return x?x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):0;
    }else {
        return "0"
    }
}

function InvCard({getFactorDetail, item}) {

    const [load, setLoad] = useState(false);

    const numberWithCommas = (x) => {
        if (x === 0) {
            return 0
        }
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }

    const convertState = (state) =>{
        switch (state) {
            case 'waiting_to_pay':
                return "منتظر پرداخت"
                break;
            case 'invalidated':
                return "نامعتبر"
                break;
            case 'success_to_pay':
                return "پرداخت شده"
                break;
        }
    }

    const convertPayState = (state) =>{
        switch (state) {
            case 1:
                return "منتظر پرداخت"
                break;
            case 2:
                return "پرداخت شده"
                break;
            case 3:
                return "بستانکار"
                break;
        }
    }





    const convertStateStyle = (state) =>{
        switch (state) {
            case 'waiting_to_pay':
                return "wait_pay"
                break;
            case 'invalidated':
                return "invalid_pay"
                break;
            case 'success_to_pay':
                return "success_pay"
                break;
        }
    }

    const convertPayStateStyle = (state) =>{
        switch (state) {
            case 1:
                return "wait_pay"
                break;
            case 2:
                return "success_pay"
                break;
            case 3:
                return "wait_pay"
                break;
        }
    }



    return (
        <div className="report-card" onClick={async () => {
            setLoad(true);
            let status = await getFactorDetail(item.uid);
            setLoad(false)

        }}>
            <div className="price">
                <SimpleLineIcon name="arrow-left"/>
                <span>ریال</span>
                <span>{numberWithCommas(item.payable_amount+item.courier_cost+item.packing_cost+item.tax_cost)}</span>
            </div>
            <div className="info">
                <div className="report-card-info-wr">
                    {/*<span>{item.merchant.name}</span>*/}
                    <span>{moment(item.created).format('jYYYY/jMM/jDD HH:mm')}</span>
                    {/*<span className={convertStateStyle(item.state)}>{convertState(item.state)}</span>*/}

                    {item.state==="success_to_pay"?
                        <span className={convertPayStateStyle(2)}>{convertPayState(2)}</span>:
                        <span className={convertPayStateStyle(item.order?.pay_status)}>{convertPayState(item.order?.pay_status)}</span>
                    }


                    <span style={{color:convertStatusStyle(item.order?.status)}}>{convertStatusCode(item.order?.status)}</span>
                </div>
                {load ? <i className="fa fa-spinner fa-spin" style={{fontSize: 28}}></i> :
                    <img src={item.merchant.thumbnail} alt="" style={{width: 40, height: 40, borderColor: '#e56767'}}/>
                }
            </div>
        </div>
    )
}




function AmountCard({item}) {
    return(
        <div className="gift-section-ticket gift-card-reward" style={{
            backgroundImage: `url("/other/reward/reward-back-card-green.svg")`,
            borderRight:"4px solid #009688"
        }}>

            <div className="gift-section-ticket-off reward_level_2" style={{flex:"3 1"}}>
                {/*<span className="gift-section-ticket-off-number"><span className="off-number">{10}</span>%</span>*/}
                {/*<span className="gift-section-ticket-off-label"> تخفیف </span>*/}
                <div className="gift-card-val">
                    <span className="gift-card-val-value" style={{color:"#009688"}}>{numberWithCommas(item.discount_value)}</span>
                    <span className="gift-card-val-title">ریال</span>
                </div>
            </div>

            <div className="gift-section-ticket-info">
                <div className="rotated-half-up-circle"></div>
                <div className="rotated-half-down-circle"></div>
                <span
                    className="gift-section-ticket-info-title" style={{fontSize:14}}>{item.campaign.title}</span>
                {/*<span className="gift-section-ticket-info-max">{coupon.code}</span>*/}
                <div className="gift-section-ticket-info-date" style={{direction:"rtl"}}>
                    <div style={{display:'flex',flexDirection:"column"}}>
                        <span style={{fontSize:13,color:"black"}}>{item.description}</span>
                        {ToDay(item.valid_to_date)}
                        {/*<span>پاداش خرید جزییات</span>*/}
                    </div>
                </div>
            </div>
        </div>
    )
}

const RewardConvertToJalali = (date) =>{
    return  moment.utc(date.split('+')[0]).format(' HH:mm - jYYYY/jMM/jDD');
}


const ToDayComp = ({first,val,second})=>{
    return(
        <span>{first}<span style={{color:"#E2620C",fontSize:14}}> { val } </span>{second}</span>
    )
}


const ToDay = (date) =>{
    const unix = moment.utc(date.split('+')[0]).unix();
    const now = Math.floor(new Date().getTime()/1000);
    const diff = unix-now;
    let result = ""

    if(diff<0)
        return <ToDayComp first={"کوپن منقضی شده"}/>

    if(diff>0){
        let day = Math.floor(diff / (3600*24));
        if(day<16)
            return <ToDayComp first={" قابل استفاده تا"} val={day} second={"روز دیگر"}/>
        else
            return <ToDayComp first={" قابل استفاده تا"} val={moment.utc(date.split('+')[0]).format(' HH:mm - jYYYY/jMM/jDD')} second={""}/>
    }

    return  result
}


function PercentCard({item}) {
    return(
        <div className="gift-section-ticket gift-card-reward" style={{
            backgroundImage: `url("/other/reward/reward-back-card-orang.svg")`,
            borderRight:"4px solid #E2620C"
        }
        }>

            <div className="gift-section-ticket-off reward_level_2" style={{flex:"3 1"}}>
                {/*<span className="gift-section-ticket-off-number"><span className="off-number">{10}</span>%</span>*/}
                {/*<span className="gift-section-ticket-off-label"> تخفیف </span>*/}
                <div className="gift-card-val">
                    <span className="gift-card-val-value" style={{color:"#E2620C"}}>{item.discount_value}</span>
                    <span className="gift-card-val-title">درصد</span>
                </div>
            </div>

            <div className="gift-section-ticket-info">
                <div className="rotated-half-up-circle"></div>
                <div className="rotated-half-down-circle"></div>
                <span
                    className="gift-section-ticket-info-title" style={{fontSize:14}}>{item.campaign.title}</span>
                {/*<span className="gift-section-ticket-info-max">{coupon.code}</span>*/}
                <div className="gift-section-ticket-info-date" style={{direction:"rtl"}}>
                    <div style={{display:'flex',flexDirection:"column"}}>
                        <span style={{fontSize:13,color:"black"}}>{item.description}</span>
                        {ToDay(item.valid_to_date)}
                        {/*<span>پاداش خرید جزییات</span>*/}
                    </div>
                </div>
            </div>
        </div>
    )
}


function PercentHistoryCard({item}) {
    return(
        <div className="gift-section-ticket gift-card-reward" style={{
            backgroundImage: `url("/other/reward/reward-back-card-orang.svg")`,
            borderRight:"4px solid #E2620C"
        }
        }>

            <div className="gift-section-ticket-off reward_level_2" style={{flex:"3 1"}}>
                {/*<span className="gift-section-ticket-off-number"><span className="off-number">{10}</span>%</span>*/}
                {/*<span className="gift-section-ticket-off-label"> تخفیف </span>*/}
                <div className="gift-card-val">
                    <span className="gift-card-val-value" style={{color:"#E2620C"}}>{item.discount_value}</span>
                    <span className="gift-card-val-title">درصد</span>
                </div>
            </div>

            <div className="gift-section-ticket-info">
                <div className="rotated-half-up-circle"></div>
                <div className="rotated-half-down-circle"></div>
                <span
                    className="gift-section-ticket-info-title" style={{fontSize:14}}>{item.campaign.title}</span>
                {/*<span className="gift-section-ticket-info-max">{coupon.code}</span>*/}
                <div className="gift-section-ticket-info-date" style={{direction:"rtl"}}>
                    <div style={{display:'flex',flexDirection:"column"}}>
                        <span style={{fontSize:13,color:"black"}}>{item.description}</span>
                        {item.consume_date?<span>مصرف شده در <span style={{color: "#E2620C"}}>{RewardConvertToJalali(item.consume_date)}</span></span>:null}
                        {/*<span>پاداش خرید جزییات</span>*/}
                    </div>
                </div>
            </div>
        </div>
    )
}


function AmountHistoryCard({item}) {
    return(
        <div className="gift-section-ticket gift-card-reward" style={{
            backgroundImage: `url("/other/reward/reward-back-card-green.svg")`,
            borderRight:"4px solid #009688"
        }}>

            <div className="gift-section-ticket-off reward_level_2" style={{flex:"3 1"}}>
                {/*<span className="gift-section-ticket-off-number"><span className="off-number">{10}</span>%</span>*/}
                {/*<span className="gift-section-ticket-off-label"> تخفیف </span>*/}
                <div className="gift-card-val">
                    <span className="gift-card-val-value" style={{color:"#009688"}}>{numberWithCommas(item.discount_value)}</span>
                    <span className="gift-card-val-title">ریال</span>
                </div>
            </div>

            <div className="gift-section-ticket-info">
                <div className="rotated-half-up-circle"></div>
                <div className="rotated-half-down-circle"></div>
                <span
                    className="gift-section-ticket-info-title" style={{fontSize:14}}>{item.campaign.title}</span>
                {/*<span className="gift-section-ticket-info-max">{coupon.code}</span>*/}
                <div className="gift-section-ticket-info-date" style={{direction:"rtl"}}>
                    <div style={{display:'flex',flexDirection:"column"}}>
                        <span style={{fontSize:13,color:"black"}}>{item.description}</span>
                        {item.consume_date?<span>مصرف شده در <span
                            style={{color: "#009688"}}>{RewardConvertToJalali(item.consume_date)}</span></span>:null}
                        {/*<span>پاداش خرید جزییات</span>*/}
                    </div>
                </div>
            </div>
        </div>
    )
}


function DefaultAmountHistoryCard({item}) {
    return(
        <div className="gift-section-ticket gift-card-reward" style={{
            backgroundImage: `url("/other/reward/reward-back-card-green.svg")`,
            borderRight:"4px solid #009688"
        }}>

            <div className="gift-section-ticket-off reward_level_2" style={{flex:"3 1"}}>
                {/*<span className="gift-section-ticket-off-number"><span className="off-number">{10}</span>%</span>*/}
                {/*<span className="gift-section-ticket-off-label"> تخفیف </span>*/}
                <div className="gift-card-val">
                    <span className="gift-card-val-value" style={{color:"#009688"}}>{numberWithCommas(item.effect.value)}</span>
                    <span className="gift-card-val-title">ریال</span>
                </div>
            </div>

            <div className="gift-section-ticket-info">
                <div className="rotated-half-up-circle"></div>
                <div className="rotated-half-down-circle"></div>
                <span
                    className="gift-section-ticket-info-title" style={{fontSize:14}}>{item.campaign_title}</span>
                {/*<span className="gift-section-ticket-info-max">{coupon.code}</span>*/}
                <div className="gift-section-ticket-info-date" style={{direction:"rtl"}}>
                    <div style={{display:'flex',flexDirection:"column"}}>
                        <span style={{fontSize:13,color:"black"}}>{item.description}</span>
                        <span>مصرف شده در <span style={{color:"#009688"}}>{RewardConvertToJalali(item.consume_date)}</span></span>
                        {/*<span>پاداش خرید جزییات</span>*/}
                    </div>
                </div>
            </div>
        </div>
    )
}


function DefaultPercentHistoryCard({item}) {
    return(
        <div className="gift-section-ticket gift-card-reward" style={{
            backgroundImage: `url("/other/reward/reward-back-card-orang.svg")`,
            borderRight:"4px solid #E2620C"
        }
        }>

            <div className="gift-section-ticket-off reward_level_2" style={{flex:"3 1"}}>
                {/*<span className="gift-section-ticket-off-number"><span className="off-number">{10}</span>%</span>*/}
                {/*<span className="gift-section-ticket-off-label"> تخفیف </span>*/}
                <div className="gift-card-val">
                    <span className="gift-card-val-value" style={{color:"#E2620C"}}>{item.effect.value}</span>
                    <span className="gift-card-val-title">درصد</span>
                </div>
            </div>

            <div className="gift-section-ticket-info">
                <div className="rotated-half-up-circle"></div>
                <div className="rotated-half-down-circle"></div>
                <span className="gift-section-ticket-info-title" style={{fontSize:14}}>{item.campaign_title}</span>
                {/*<span className="gift-section-ticket-info-max">{coupon.code}</span>*/}
                <div className="gift-section-ticket-info-date" style={{direction:"rtl"}}>
                    <div style={{display:'flex',flexDirection:"column"}}>
                        <span style={{fontSize:13,color:"black"}}>{item.description}</span>
                        {item.is_consumed?<span>مصرف شده در <span style={{color:"#E2620C"}}>{RewardConvertToJalali(item.consume_date)}</span></span>:null}
                        {!item.is_consumed?<span>قابل استفاده تا  <span style={{color:"#E2620C"}}>{RewardConvertToJalali(item.consume_date)}</span></span>:null}
                        {/*<span>پاداش خرید جزییات</span>*/}
                    </div>
                </div>
            </div>
        </div>
    )
}




function RewardCard({item,showModal}) {

    switch (item.coupon_type) {
        case 'discount_percent':
            return(
                <div onClick={()=>showModal(item)}>
                    <PercentCard item={item}/>
                </div>
            )
            break
        case 'discount_amount':
            return(
                <div onClick={()=>showModal(item)}>
                    <AmountCard item={item}/>
                </div>
            )
            break
        case 'real_time_discount_percent':
            return(
                <div onClick={()=>showModal(item)}>
                    <DefaultPercentHistoryCard item={item}/>
                </div>
            )
            break
        case 'real_time_discount_amount':
            return(
                <div onClick={()=>showModal(item)}>
                    <DefaultAmountHistoryCard item={item}/>
                </div>
            )
            break
        default:
            return (
                <span></span>
            )
    }
}



function RewardHistoryCard({item,showModal}) {

    switch (item.coupon_type) {
        case 'discount_percent':
            return(
                <div onClick={()=>showModal(item)}>
                    <PercentHistoryCard item={item}/>
                </div>
            )
            break
        case 'discount_amount':
            return(
                <div onClick={()=>showModal(item)}>
                    <AmountHistoryCard item={item}/>
                </div>
            )
            break
        case 'generate_coupon_discount_percent':
            return(
                <div onClick={()=>showModal(item)}>
                    <PercentHistoryCard item={item}/>
                </div>
            )
            break
        case 'generate_coupon_discount_amount':
            return(
                <div onClick={()=>showModal(item)}>
                    <AmountHistoryCard item={item}/>
                </div>
            )
            break
        case 'real_time_discount_percent':
            return(
                <div onClick={()=>showModal(item)}>
                    <DefaultPercentHistoryCard item={item}/>
                </div>
            )
            break
        case 'real_time_discount_amount':
            return(
                <div onClick={()=>showModal(item)}>
                    <DefaultAmountHistoryCard item={item}/>
                </div>
            )
            break
        default:
            return (
                <span></span>
            )
    }
}



function OrderCard({item}) {
    return(
        <div>
            order item ...
        </div>
    )
}


function Reward() {

    const [rewards,set_rewards] = useState([]);
    const [rewardsHistory,set_rewardsHistory] = useState([]);
    const [orders,set_orders] = useState([]);
    const [activeTab,set_activeTab] = useState("order");
    const [rewardModal,set_rewardModal] = useState("reward");
    const [creditCard,set_creditCard] = useState({});
    const [cardLogo,set_cardLogo] = useState(localStorage.getItem("mallLogo"))

    const resp = useResp();
    let history = useHistory();
    const location = useLocation()

    const [nav_label,set_nav_label] = useState(null)


    useEffect(()=>{
        if(location.state && location.state.navLabel)
            set_nav_label(location.state.navLabel)
    },[])

    //-----------------------------------------------rewards---------------------------------------
    useEffect(()=>{
        getRewards()
        getCreditCard()
        let user = localStorage.getItem("user")
        if(user){
            set_user(JSON.parse(user))
        }
    },[])


    const getRewards = async ()=>{
        const res = await UserCouponData()
        set_rewards(res.data.results)
        reward_next = res.data.next
    }

    const getRewardPage = async () => {
        try {
            const reportData = await UserCouponDataPage(reward_next);
            setLoad(false)
            reward_next = reportData.data.next
            set_rewards((list)=>[...list,...reportData.data.results]);
        } catch (e) {
            setLoad(false)
            // console.log(e)
        }
    }


    const getRewardsHistory = async ()=>{
        const res = await UserCouponData(true)
        set_rewardsHistory(res.data.results)
        reward_history_next = res.data.next
    }

    const getRewardHistoryPage = async () => {
        try {
            const reportData = await UserCouponDataPage(reward_history_next,true);
            setLoad(false)
            reward_history_next = reportData.data.next
            set_rewardsHistory((list)=>[...list,...reportData.data.results]);
        } catch (e) {
            setLoad(false)
            // console.log(e)
        }
    }



    const getCreditCard = async ()=>{
        const res = await MallCreditCard()
        set_creditCard(res.data)
    }

    //----------------------------------------------------- orders ------------------------------------------------------------------------

    const [selectedReport, setSelectedReport] = useState("cat");
    const [showModal, setShowModal] = useState(false);
    const [showRewardModal, setShowRewardModal] = useState(false);
    const [factor, setFactor] = useState({});
    const [user, set_user] = useState({});


    const numberWithCommas = (x) => {
        if (x === 0) {
            return 0
        }
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }



    const [invo, setInvo] = useState([])
    const [load, setLoad] = useState(true)

    const getReport = async () => {
        try {
            const reportData = await ReportData();
            setLoad(false)
            // console.log("re", reportData)
            setInvo(reportData.data.results)
        } catch (e) {
            setLoad(false)
            // console.log(e)
        }
    }

    const getReportPage = async () => {
        try {
            const reportData = await ReportData(window.currentPage);
            setLoad(false)
            // console.log("re", reportData)
            setInvo((list)=>[...list,...reportData.data.results]);
        } catch (e) {
            setLoad(false)
            // console.log(e)
        }
    }


    const HandleScrollListener = async () =>{
        const doc = document.documentElement;
        let calc = doc.scrollHeight -(doc.scrollTop + doc.clientHeight)
        let cond = calc>3 || calc<-3
        // let cond = calc!==0

        if(!cond) {
            window.currentPage = window.currentPage +1

            switch (globalActiveTab) {
                case "reward":
                    getRewardPage()
                    break;
                case "order":
                    getReportPage()
                    break
                case "reward_history":
                    getRewardHistoryPage()
                    break
            }

        }

    }

    useEffect(()=>{
        //handle scroll arrived to Top
        window.currentPage = 1;
        window.addEventListener('scroll',HandleScrollListener);
        return () => {
            window.removeEventListener('scroll', HandleScrollListener); // Remove Scroll Event Listener
        };
    },[])

    const adjustDesktopCopoun = ()=>{
        // let width = mobileWidth?mobileWidth:document?.getElementById('mobile-sec')?.clientWidth
        //
        // //mask
        // let mask = document.getElementsByClassName("rodal-mask")[0]
        // mask.style.width=(width+20)+"px"
        //
        // //dialog
        // setTimeout(()=>{
        //     let dialog = document.getElementsByClassName("rodal-zoom-enter")[0]
        //     console.log(dialog)
        //     dialog.style.width = (width-50)+"px"
        //     dialog.style.left = "auto"
        //     dialog.style.right = "15px"
        // },0)
    }


    const adjustDesktopFactor = ()=>{
        // let width = mobileWidth?mobileWidth:document?.getElementById('mobile-sec')?.clientWidth
        //
        // //mask
        // let mask = document.getElementsByClassName("rodal-mask")[1]
        // mask.style.width=(width+20)+"px"
        //
        // //dialog
        // let dialog = document.getElementsByClassName("rodal-zoom-enter")[0]
        // dialog.style.width = (width-50)+"px"
        // dialog.style.left = "auto"
        // dialog.style.right = "15px"
    }

    const getFactorDetail = async (id) => {
        try {
            const factor = await FactorData(id);
            setFactor(factor.data);
            setShowModal(true)
            adjustDesktopFactor()
            return true;
        } catch (e) {
            // console.log(e)
            return false;
        }
    }


    useEffect(() => {
        window.scrollTo(0, 0);
        getReport().then()
        getRewardsHistory()
    }, [])

    //----------------------------------------------------- orders ------------------------------------------------------------------------


    const showRewardM = (item)=>{
        set_rewardModal(item)
        setShowRewardModal(true)
        adjustDesktopCopoun()
    }

    const convertUnitCard = (type)=>{
        switch (type) {
            case 'discount_percent':
                return "درصد";
                break;
            case 'discount_amount':
                return "ریال";
                break;
            case 'generate_coupon_discount_percent':
                return "درصد";
                break;
            case 'generate_coupon_discount_amount':
                return "ریال";
                break;
            default:
                return "-";
        }
    }

    const convertTypeCard = (type)=>{
        switch (type) {
            case 'discount_percent':
                return "درصدی";
                break;
            case 'discount_amount':
                return "مبلغی";
                break;
            case 'generate_coupon_discount_percent':
                return "درصدی";
                break;
            case 'generate_coupon_discount_amount':
                return "مبلغی";
                break;
            default:
                return "-";
        }
    }


    const [localMall,setLocalMall] = useState(null);
    const [festivalsStatus,set_festivalsStatus] = useState(false);
    useEffect(()=>{
        let lMall = localStorage.getItem("mall")
        if(lMall)
            setLocalMall(JSON.parse(lMall));


        getFestivalsStatus()
    },[])


    const getFestivalsStatus = async() => {
        try{
            const res = await getFestivalsStatus_api()
            console.log("re" , res.data)
            if(res.data.length>0)
                set_festivalsStatus(true)
            else
                set_festivalsStatus(false)
        }catch(e){
            console.error(e)
        }
    }


    const { height, width,mobileWidth } = useWindowDimensions();

    const directPay = async (f)=>{
        console.log("f",f)

        try {
            //create invoice
            let req = {
                amount: f.payable_amount,
                client_callback: window.location.origin+"/dr-shop/bank-result/"+f.uid,
                res_num: f.uid,
                merchant_uid: f.merchant.uid
            }
            const response = await StoreOnlineCreateInvoice(req);
            history.push(`/dr-shop/pay/${f.merchant.uid}`, {create: response.data,finalObj:{invoice:f}})
            // history.push(`/dr-shop/preinvoice/${f.merchant.uid}`, {create: response.data})
        } catch (e) {
            // console.log(e)
            return
        }
    }



    return(
        <div className="reward-container">



            <Modal visible={showRewardModal} footer={null}  onCancel={() => setShowRewardModal(false)}   closable={false} bodyStyle={{padding:0}}>

                <div className="modal-wrapper">






                    {rewardModal.coupon_type?<div className="reward-modal">
                        <div className="reward-modal-header">
                            <span>{rewardModal.campaign.title}</span>
                        </div>
                        <div className="reward-modal-list">
                            <div className="reward-modal-item">
                                <span>{rewardModal.discount_value} {convertUnitCard(rewardModal.coupon_type)}</span>
                                <span>ارزش کوپن</span>
                            </div>
                            <div className="reward-modal-item">
                                <span>{convertTypeCard(rewardModal.coupon_type)}</span>
                                <span>نوع</span>
                            </div>
                            {/*<div className="reward-modal-item">*/}
                            {/*    <span style={{color:"#009688",display:'flex',alignItems:"center"}} onClick={()=>history.push(`/store-detail/${rewardModal.merchant.uid}`)}>*/}
                            {/*        /!*<span>{rewardModal.merchant.name}</span>*!/*/}
                            {/*        <span> > </span>*/}
                            {/*         </span>*/}
                            {/*    <span>قابل استفاده در</span>*/}
                            {/*</div>*/}
                            <div className="reward-modal-item">
                                <span>{RewardConvertToJalali(rewardModal.created)}</span>
                                <span>ایجاد شده در </span>
                            </div>
                            <div className="reward-modal-item">
                                <span>{RewardConvertToJalali(rewardModal.valid_to_date)}</span>
                                <span>قابل استفاده تا</span>
                            </div>
                        </div>

                        <div className="reward-modal-qr">

                            {rewardModal.coupon_type?
                                <>
                                    <div className="reward-modal-qr-id">
                                        <span>{rewardModal.code}</span>
                                        <span>شناسه</span>
                                    </div>
                                    <div className="reward-modal-qr-img">
                                        <QRCode size={128} value={rewardModal.code} />
                                    </div>
                                </>
                                :null}
                        </div>

                    </div>:null}



                </div>

            </Modal>

            {/*<Rodal  animation={"zoom"}  visible={showRewardModal} onClose={() => setShowRewardModal(false)}>*/}
            {/*    */}
            {/*    {rewardModal.coupon_type?<div className="reward-modal">*/}
            {/*        <div className="reward-modal-header">*/}
            {/*            <span>{rewardModal.campaign.title}</span>*/}
            {/*        </div>*/}
            {/*        <div className="reward-modal-list">*/}
            {/*            <div className="reward-modal-item">*/}
            {/*                <span>{rewardModal.discount_value} {convertUnitCard(rewardModal.coupon_type)}</span>*/}
            {/*                <span>ارزش کوپن</span>*/}
            {/*            </div>*/}
            {/*            <div className="reward-modal-item">*/}
            {/*                <span>{convertTypeCard(rewardModal.coupon_type)}</span>*/}
            {/*                <span>نوع</span>*/}
            {/*            </div>*/}
            {/*            /!*<div className="reward-modal-item">*!/*/}
            {/*            /!*    <span style={{color:"#009688",display:'flex',alignItems:"center"}} onClick={()=>history.push(`/store-detail/${rewardModal.merchant.uid}`)}>*!/*/}
            {/*            /!*        /!*<span>{rewardModal.merchant.name}</span>*!/*!/*/}
            {/*            /!*        <span> > </span>*!/*/}
            {/*            /!*         </span>*!/*/}
            {/*            /!*    <span>قابل استفاده در</span>*!/*/}
            {/*            /!*</div>*!/*/}
            {/*            <div className="reward-modal-item">*/}
            {/*                <span>{RewardConvertToJalali(rewardModal.created)}</span>*/}
            {/*                <span>ایجاد شده در </span>*/}
            {/*            </div>*/}
            {/*            <div className="reward-modal-item">*/}
            {/*                <span>{RewardConvertToJalali(rewardModal.valid_to_date)}</span>*/}
            {/*                <span>قابل استفاده تا</span>*/}
            {/*            </div>*/}
            {/*        </div>*/}

            {/*        <div className="reward-modal-qr">*/}

            {/*            {rewardModal.coupon_type?*/}
            {/*                <>*/}
            {/*                    <div className="reward-modal-qr-id">*/}
            {/*                        <span>{rewardModal.code}</span>*/}
            {/*                        <span>شناسه</span>*/}
            {/*                    </div>*/}
            {/*                    <div className="reward-modal-qr-img">*/}
            {/*                        <QRCode size={128} value={rewardModal.code} />*/}
            {/*                    </div>*/}
            {/*                </>*/}
            {/*                :null}*/}
            {/*        </div>*/}

            {/*    </div>:null}*/}
            {/*</Rodal>*/}


            <Modal visible={showModal} footer={null}  onCancel={() => setShowModal(false)}   closable={false} bodyStyle={{padding:0}}>

                <div className="modal-wrapper">






                    <div className="factor-header">
                        <div className="factor-header-item left">
                            <span className="factor-header-item-title">کد تحویل</span>
                            <span> --- </span>
                        </div>
                        <div className="factor-header-item right">
                            <span className="factor-header-item-title">تاریخ</span>
                            {factor.created ?
                                <span className="factor-header-item-val">{ConvertToJalali(factor.created)}</span> : null}
                        </div>
                        <div className="factor-header-item right">
                            <span className="factor-header-item-title">شماره فاکتور</span>
                            {factor.uid ? <span className="factor-header-item-val">{factor.id}</span> : null}
                        </div>
                    </div>

                    <div className="factor-table">
                        <table>
                            <thead>
                            <tr>
                                <th className="product-table-head">جمع کل</th>
                                {/*<th className="product-table-head">تخفیف</th>*/}
                                <th className="product-table-head">تعداد</th>
                                <th className="product-table-head product-table-head-name">نام کالا</th>
                                <th className="product-table-head product-table-head-name">تصویر</th>
                            </tr>
                            </thead>
                            <tbody>
                            {factor.products && factor.products.map(product => {
                                return (
                                    <tr key={product.uid}>
                                        <td className="product-price">{numberWithCommas(product.amount)}</td>
                                        {/*<td className="product-count">{numberWithCommas(product.per_discount)}</td>*/}
                                        <td className="product-count">{product.quantity}</td>
                                        <td className="product-name">{product.name?product.name:product.product.name}</td>
                                        <td className="product-name">
                                            {product.product?<img src={product.product && product.product.image ? product.product.image : "/other/skeleton/product.jpg"} alt=""/>:null}
                                        </td>
                                    </tr>
                                )
                            })
                            }
                            </tbody>
                        </table>


                        <div className="factor-result">
                            <div className="factor-table-total-row">
                                <div className="factor-table-total--price">
                                    <span>ریال</span>
                                    {factor.payable_amount ? <span>{numberWithCommas(factor.amount+factor.discount_sum_on_products)}</span> : null}
                                </div>
                                <span> : مبلغ فاکتور  </span>
                            </div>

                            <div className="factor-table-total-row">
                                <div className="factor-table-total--price">
                                    <span>ریال</span>
                                    <span>{factor.courier_cost?factor.courier_cost:0}</span>
                                </div>
                                <span> : هزینه پیک  </span>
                            </div>

                            <div className="factor-table-total-row">
                                <div className="factor-table-total--price">
                                    <span>ریال</span>
                                    <span>{factor.packing_cost?factor.packing_cost:0}</span>
                                </div>
                                <span> : هزینه بسته بندی  </span>
                            </div>

                            <div className="factor-table-total-row">
                                <div className="factor-table-total--price">
                                    <span>ریال</span>
                                    <span>{factor.tax_cost?factor.tax_cost:0}</span>
                                </div>
                                <span> : مالیات بر ارزش افزوده  </span>
                            </div>

                            <div className="factor-table-total-row customer_discount-row">
                                <div className="factor-table-total--price customer_discount-val">
                                    <span>ریال</span>
                                    {<span>{numberWithCommas(factor.discount_sum_on_products)}</span>}
                                </div>
                                <span className="customer_discount"> : تخفیف  اقلام  </span>
                            </div>

                            {/*<div className="factor-table-total-row customer_discount-row">*/}
                            {/*    <div className="factor-table-total--price customer_discount-val">*/}
                            {/*        <span>ریال</span>*/}
                            {/*        {<span>{numberWithCommas(factor.discount_amount+factor.client_discount_amount)}</span>}*/}
                            {/*    </div>*/}
                            {/*    <span className="customer_discount"> : تخفیف  کوپن  </span>*/}
                            {/*</div>*/}

                            <div className="factor-table-total-row customer_discount-row">
                                <div className="factor-table-total--price customer_discount-val">
                                    <span>ریال</span>
                                    {<span>{numberWithCommas(factor.discount_amount_sum)}</span>}
                                </div>
                                <span className="customer_discount"> : مجموع تخفیف  </span>
                            </div>

                            {factor.state==="waiting_to_pay" && factor.amount-factor.payable_amount>0?<div className="factor-table-total-row payed-before-row">
                                <div className="factor-table-total--price">
                                    <span>ریال</span>
                                    {factor.payable_amount ? <span>{numberWithCommas(factor.amount-factor.payable_amount-(factor.discount_amount+factor.client_discount_amount))}</span> : null}
                                </div>
                                <span> : مبلغ پرداخت شده  </span>
                            </div>:null}

                            <div className="factor-table-total-row">
                                <div className="factor-table-total--price">
                                    <span>ریال</span>
                                    {factor.payable_amount ? <span>{numberWithCommas(factor.payable_amount+factor.courier_cost+factor.packing_cost+factor.tax_cost)}</span> : null}
                                </div>
                                <span> : مبلغ قابل پرداخت  </span>
                            </div>
                        </div>

                        {factor?.order?.pay_status===1?<div className="invoice-pay-sec" onClick={e=>{
                            directPay(factor)
                        }}>
                            <span className="invoice-pay-btn">پرداخت</span>
                        </div>:null}

                        {factor?.order?.delivery_data?.trip?<div className="delivery-data">
                            <div className="delivery-data-item">
                                <div className="delivery-data-item-value">
                                    <span style={{color:convertStatusStyle(factor?.order?.status)}}>{convertStatusCode(factor?.order?.status)}</span>
                                </div>
                                <div className="delivery-data-item-label">
                                    <span>وضعیت ارسال</span>
                                </div>
                            </div>

                            {factor?.order?.delivery_data?.trip?.courier?.name?<div className="delivery-data-item">
                                <div className="delivery-data-item-value">
                                    <span>{factor?.order?.delivery_data?.trip?.courier?.name}</span>
                                </div>
                                <div className="delivery-data-item-label">
                                    <span>نام پیک</span>
                                </div>
                            </div>:null}

                            <div className="delivery-data-item">
                                <div className="delivery-data-item-value">
                                    <span>{factor?.order?.delivery_data?.trip?.courses[0].address}</span>
                                </div>
                                <div className="delivery-data-item-label">
                                    <span>آدرس شما : </span>
                                </div>
                            </div>

                            {factor?.order?.delivery_data?.trip?.courier?.name?<div className="delivery-data-item-btn">
                                <span onClick={e=>{
                                    let url = factor?.order?.delivery_data?.trip?.courses[0].tracking_url;
                                    window.open(url, "_blank")
                                }}>پیگیری لحظه ای سفارش</span>
                            </div>:null}

                        </div>:null}

                    </div>



                </div>

            </Modal>

            {/*<Rodal width={"200px !important"}  animation={"zoom"} visible={showModal} onClose={() => setShowModal(false)}></Rodal>*/}


            {resp?<div className="home-container-res">
                <RewardResponsive
                history={history}
                InvCard={InvCard}
                InvCard_skeleton={InvCard_skeleton}
                showRewardM={showRewardM}
                load={load}
                user={user}
                RewardHistoryCard={RewardHistoryCard}
                rewardsHistory={rewardsHistory}
                selectedReport={selectedReport}
                RewardCard={RewardCard}
                invo={invo}
                getFactorDetail={getFactorDetail}
                creditCard={creditCard}
                globalActiveTab={globalActiveTab}
                set_activeTab={set_activeTab}
                activeTab={activeTab}
                rewards={rewards}

                />
            </div>:null}

            {!resp?
                <div >

                    {/*header*/}
                    <div className="report-header-new">
                        {/*<span>پاداش ها</span>*/}
                        <img src={localMall?.header_image} alt="" />
                        {/*<i*/}
                        {/*    onClick={() => history.goBack()}*/}
                        {/*    className="fa fa-arrow-left"></i>*/}
                    </div>

                    <div className="reward-body">
                        {/*Credit Card*/}
                        <div className="creditCard" style={{backgroundImage: `url(${creditCard.cover})`}}>

                            <div className="card-title-sec">
                                <span style={{color:`#${creditCard.title_color?creditCard.title_color:"#ffffff"}`}}>{creditCard.title}</span>
                            </div>

                            {/*<div className="card-log-sec">*/}
                            {/*    <img src={creditCard.image}  style={{width:100,height:100,padding:24}} alt="" />*/}
                            {/*</div>*/}

                            {/*<div className="rewardCard-logo">*/}
                            {/*    /!*<img src="/other/reward/reward_logo.svg" alt=""/>*!/*/}
                            {/*    <img src={creditCard.image} alt="" />*/}
                            {/*</div>*/}

                            {/*<div className="rewardCard_name" style={{color:`#${creditCard.title_color?creditCard.title_color:"#ffffff"}`}}>*/}
                            {/*    <span>{creditCard.title}</span>*/}
                            {/*</div>*/}

                            <div className="rewardCard-info" onClick={()=>{
                                history.push("/profile")
                            }}>
                                {/*<span>{creditCard.uid?creditCard.uid:"---"}</span>*/}
                                <span style={{color:`#${creditCard.name_color?creditCard.name_color:"#ffffff"}`}}>{user && user.first_name ? user.first_name+" "+user.last_name:"نام خود را وارد نمایید"  }</span>
                            </div>

                            <div className="rewardCard-credit">
                                <span style={{color:`#${creditCard.point_color?creditCard.point_color:"#ffffff"}`}}>موجودی : {creditCard.uid?creditCard.card_points:"-"} امتیاز</span>
                            </div>

                        </div>


                        {/*{festivalsStatus?<div className="reward-banner" onClick={e=>{*/}
                        {/*    history.push("/festivals")*/}
                        {/*}}>*/}
                        {/*    <img src="https://s3.mobank.co/loyalty-media/page/section_item/images/Group_3548_SYwCIa7.png" alt=""/>*/}
                        {/*</div>:null}*/}


                        {/*Options list*/}
                        <div className="options-list">
                            <div className="options-item reward-question-btn" onClick={()=>history.push("/festivals",{credit:creditCard})}>
                                {/*<img src="/other/reward/reward_q.svg" alt=""/>*/}
                                <img src="/other/sample1.gif" alt=""/>
                                <span>جشنواره</span>
                            </div>

                            <div className="options-item reward-gift-btn"
                                 onClick={()=>history.push("/awards")}
                            >
                                {/*<img src="/other/reward/reward_gift.svg" alt=""/>*/}
                                <img src="/other/sample2.gif" alt=""/>
                                <span>جایزه</span>
                            </div>
                        </div>



                        {/*new tabs*/}
                        <div className="new-tabs">
                            <div  className={activeTab==="order"?"new-tabs-item new-tabs-item-active":"new-tabs-item"}

                                  onClick={()=>{
                                      window.currentPage = 1;
                                      set_activeTab("order")
                                      globalActiveTab = "order"

                                  }} >
                                {activeTab==="order"?<img src="/other/order_tab_selected.png" alt=""/>:<img src="/other/order_tab_default.jpg" alt=""/>}
                                <span>سفارش ها</span>
                            </div>
                            <div className={activeTab==="reward_history"?"new-tabs-item new-tabs-item-active":"new-tabs-item"}

                                 onClick={()=>{
                                     window.currentPage = 1;
                                     set_activeTab("reward_history")
                                     globalActiveTab = "reward_history"
                                 }} >
                                {activeTab==="reward_history"?<img src="/other/history_tab_selected.png" alt=""/>:<img src="/other/history_tab_default.png" alt=""/>}
                                <span>تاریخچه امتیازها</span>
                            </div>
                            <div
                                className={activeTab==="reward"?"new-tabs-item new-tabs-item-active":"new-tabs-item"}
                                onClick={()=>{
                                    window.currentPage = 1;
                                    set_activeTab("reward")
                                    globalActiveTab = "reward"
                                }}>
                                {activeTab==="reward"?<img src="/other/reward_tab_selected.png" alt=""/>:<img src="/other/reward_tab_default.png" alt=""/>}
                                <span>تخفیف ها</span>
                            </div>
                        </div>


                        {/*rewards & order tabs */}
                        <div className="tabs">


                            {activeTab==="reward"?
                                <div className="rewards-tab">
                                    <div className="rewards-tab-list">
                                        {rewards.map(i=>{
                                            return(
                                                <RewardCard showModal={showRewardM} item={i}/>
                                            )
                                        })}
                                    </div>
                                </div>:null}

                            {activeTab==="reward_history"?
                                <div className="rewards-tab">
                                    <div className="rewards-tab-list">
                                        {rewardsHistory.map(i=>{
                                            return(
                                                <RewardHistoryCard showModal={showRewardM} item={i}/>
                                            )
                                        })}
                                    </div>
                                </div>:null}

                            {activeTab==="order"?
                                <div className="orders-tab">
                                    <div className="orders-tab-list">
                                        {selectedReport === "cat" ? <div className="cat-list">
                                            {invo.length < 1 ?
                                                <>
                                                    <InvCard_skeleton show={load}/>
                                                </>
                                                : null}
                                            {invo.map(item => {
                                                return (
                                                    <InvCard item={item} getFactorDetail={getFactorDetail}/>
                                                )
                                            })}
                                        </div> : null}
                                    </div>
                                </div>:null
                            }


                        </div>
                    </div>

                </div>:null
            }




            {!resp?<Nav/>:null}
        </div>
    )

}

export default Reward;
